import { render, staticRenderFns } from "./nbq_list.vue?vue&type=template&id=141c2e27&"
import script from "./nbq_list.vue?vue&type=script&lang=js&"
export * from "./nbq_list.vue?vue&type=script&lang=js&"
import style0 from "./nbq_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports